module.exports = __webpack_public_path__ + "static/img/nzsm.5f0d081.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nzsm.jpg
// module id = e8pZ
// module chunks = 1